import { MaintenanceForwardingSectionsProps } from "../../../../../features/forwardings/types/maintenanceForwarding.type";
import MaintenanceWorkflowForwardinCheckinEntrySection from "../../sections/CheckinEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../sections/EstablishmentChoiceEntry";


const MaintenanceWorkflowForwardingOnGoingEstablishmentChoice = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  return (
    <div className="flex-1 overflow-auto flex flex-col gap-4">
      <MaintenanceWorkflowForwardinCheckinEntrySection
        forwarding={forwarding}
      />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection
        forwarding={forwarding}
      />
    </div>
  );
}

export default MaintenanceWorkflowForwardingOnGoingEstablishmentChoice;
